/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentProject_ProjectVersions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Project Version API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, June 17, 2019 - 09:49:02 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      06/17/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Project_ProjectVersions = {
    all: (projectid) => requests.get(`/ProjectVersions?projectid=${projectid}`),
    get: projectversionid => requests.get(`/ProjectVersion/${projectversionid}`),
    create: projectversion => requests.post(`/ProjectVersions`, projectversion),
    update: (projectversionid, projectversion) => requests.put(`/ProjectVersion/${projectversionid}`, projectversion),
    delete: (projectversionid, projectid) => requests.del(`/ProjectVersion/${projectversionid}?projectid=${projectid}`),
};